import { SubPageShell } from "@/components/site/SubPage";
import Blog from "@/components/site/Blog";
import { useSeo } from "@/lib/useSeo";

export default function GuidePage() {
  useSeo({
    title: "Guide per proprietari di case vacanze in Sicilia | YU YieldUp",
    description:
      "Articoli brevi e pratici per chi gestisce una casa vacanze, un B&B o una struttura ricettiva in Sicilia: prezzi, annunci, portali, recensioni e gestione quotidiana.",
  });

  return (
    <SubPageShell>
      <div data-testid="guide-page" />
      <Blog />
    </SubPageShell>
  );
}
